<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed } from 'vue';

const props = defineProps({
    size: {
        type: String as PropType<'md' | 'lg'>,
        default: 'md'
    }
});

const sizeClass = computed(() => `login-card-${props.size}`);
</script>

<template>
    <SCard class="login-card shadow-sm" :class="sizeClass">
        <SCardTitle is="h1" class="mb-3">
            <SSysarbLogoLong class="mb-4"></SSysarbLogoLong>
        </SCardTitle>
        <slot></slot>
    </SCard>
</template>
